function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6V14M5.5 10H13.5M2.5 1H16.5C17.6046 1 18.5 1.89543 18.5 3V17C18.5 18.1046 17.6046 19 16.5 19H2.5C1.39543 19 0.5 18.1046 0.5 17V3C0.5 1.89543 1.39543 1 2.5 1Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.359530f0322b165fee952a5c87aae373.svg";
export { ForwardRef as ReactComponent };